import { render, staticRenderFns } from "./sing_table.vue?vue&type=template&id=4d98fb24"
import script from "./sing_table.vue?vue&type=script&lang=js"
export * from "./sing_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d98fb24')) {
      api.createRecord('4d98fb24', component.options)
    } else {
      api.reload('4d98fb24', component.options)
    }
    module.hot.accept("./sing_table.vue?vue&type=template&id=4d98fb24", function () {
      api.rerender('4d98fb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/detail/sing_table.vue"
export default component.exports